!function($) {

    // Document ready
    $(function() {
        let parent;
        $('.js-add-donation').click(function(e) {
            parent = $(this).closest('article');

            if (this.dataset.amount) {
                parent.find('.quantity').val(this.dataset.amount);
            }

            $.post('/cart/add.js', {
                items: [
                    {
                        'quantity': parent.find('.quantity').val(),
                        'id': $("#option-select-" + parent.attr('id')).val()
                    }
                ]
            }, function() {
                parent.find('.js-donation-message').fadeIn(650);
                $.get('/cart.js', function(data) {
                    let count = 0;
                    for (item of data.items) {
                        if (item.handle.indexOf('donate') !== -1) {
                            count++;
                        } else {
                            count += item.quantity;
                        }
                    }
                    if ($('.cart .item-count').length === 0) {
                        $('.cart').append("<span class=\"item-count inline-block text-center\">\n" + count + "\n</span>\n");
                    } else {
                        $('.item-count').html(count);
                    }
                }, 'json');
            }, 'json');
        });

        $('.js-other-donation-button').click(function(e) {
            parent = $(this).closest('article');
            parent.find('.donation-add-to-cart-buttons').toggle();
            let display = 'flex';
            if (parent.find('.js-other-donation-amount').is(':visible')) {
                display = 'none';
            }
            parent.find('.js-other-donation-amount').css('display', display);
        });

        $('.page summary').on('click', function(e) {
            let currentlyOpen = $('details[open]')[0];
            let clickedDetails = $(this).closest('details')[0];

            $('details').removeAttr('open');

            if (currentlyOpen !== clickedDetails) {
                $(clickedDetails).attr('open', '');
            }

            e.preventDefault();
        });
    });
}(jQuery);